import { AdAnalyticsPlacementTypes, createAdAnalyticsPlacementTypes } from '@kaizenplatform/hugot-entity';
import gql from 'graphql-tag';

import GraphQLClient from '../../adapter/GraphQLClient';

class AdAnalyticsPlacementTypesWebApi {
  private readonly graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getAdAnalyticsPlacementTypes = async (): Promise<AdAnalyticsPlacementTypes> => {
    const result = await this.graphqlClient.query(
      gql`
        query adAnalyticsPlacementTypes {
          adAnalyticsPlacementTypes {
            platforms {
              key
              name
              networks {
                key
                name
                placements {
                  key
                  name
                }
              }
            }
            periods
          }
        }
      `,
      {},
    );

    const { platforms, periods } = result.adAnalyticsPlacementTypes;
    return AdAnalyticsPlacementTypes.fromJSON({
      platforms: platforms,
      periods: periods,
    });
  };

  // Mock
  // ---------------------------------------------------------
  public getAdAnalyticsPlacementTypesMock = async (): Promise<AdAnalyticsPlacementTypes> => {
    return createAdAnalyticsPlacementTypes();
  };
}

export default AdAnalyticsPlacementTypesWebApi;
